import React from 'react';
import InputLabel from '../../widgets/input-label';
import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Defaults from '../../../../shared/constants/defaults';
import FormSettings from '../../../../shared/constants/form-settings';
import TinyMCE from 'react-tinymce';
import FormActions from '../../../../shared/actions/form';
import objectAssign from 'object-assign';
import InputHint from '../../widgets/input-hint';
import InputPlaceholder from '../../widgets/input-placeholder';
import ElementConstants from '../../../../shared/constants/elements';

export default class AddressElement extends React.Component {
	constructor(props) {
		super(props);
		this.props.data.initialized = false;
	}

	componentDidUpdate() {
		if ( !this.props.data.initialized ) {
			const {
				fieldsetIndex,
				rowIndex,
				index
			} = this.props;

			FormActions.initializeAddress(fieldsetIndex, rowIndex, index);
			this.props.data.initialized = true;
			/**
			 * FormActions.removeElement is used to remove the empty div that is generated
			 * as a side effect of this react component
			 */
			FormActions.removeElement(this.props.fieldsetIndex, this.props.rowIndex, this.props.index);
		}
	}

	render(){
		/**
		 * this div will be eliminated  on 'componentDidUpdate()'
		 */
		return(
			<div>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/address.js